/* AnnouncementModal.constants.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import OpenIcon from '@atlaskit/icon/glyph/open';
import { ExternalLink } from '@atlassian/mpac-ui';
import React from 'react';
const _2 = "._otyr1ejb{margin-bottom:var(--ds-space-300,24px)}";
const _ = "._19pk1ejb{margin-top:var(--ds-space-300,24px)}";
const ModalContent = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pk1ejb _otyr1ejb", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ModalContent.displayName = 'ModalContent';
}
function CategoriesAnnouncementBody() {
  return /*#__PURE__*/React.createElement(ModalContent, null, /*#__PURE__*/React.createElement("p", null, "We are introducing", ' ', /*#__PURE__*/React.createElement(ExternalLink, {
    href: "https://developer.atlassian.com/platform/marketplace/new-app-categorization-system-in-marketplace/"
  }, "a new categorization system in Marketplace", /*#__PURE__*/React.createElement(OpenIcon, {
    label: "Icon that represent the link open in new tab",
    size: "small"
  })), ' ', "to facilitate an efficient app discovery and frictionless navigation. The new experience will help partners connect their apps to the right audience and the apps will be appropriately discoverable under the selected category."));
}
export const categoriesAnnouncementMessage = {
  header: 'New categorization system in Marketplace',
  body: /*#__PURE__*/React.createElement(CategoriesAnnouncementBody, null),
  leftButton: 'Understood',
  rightButton: 'Learn more about new categorization'
};